import Masonry from 'masonry-layout/dist/masonry.pkgd.min'
import imagesLoaded from 'imagesloaded'

export const imageBlockArticleMagazine = (widget) => {
  const msnry = new Masonry(widget, {
    itemSelector: '.four-image-container__item',
    static: true,
    useMin: true,
    horizontalOrder: true,
  })

  imagesLoaded(widget).on('progress', () => {
    msnry.layout()
  })
}
